import script from "./SkillDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillDetails.vue?vue&type=script&setup=true&lang=js"

import "./SkillDetails.vue?vue&type=style&index=0&id=417595a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417595a4"]])

export default __exports__